<ng-select
  [items]="selectOptions"
  [bindLabel]="props['bindLabel'] || 'label'"
  [bindValue]="props['bindValue'] || 'value'"
  [placeholder]="props.placeholder || 'Select'"
  [multiple]="true"
  [closeOnSelect]="false"
  [formControl]="formControl"
  [clearable]="props['clearable'] !== false"
  [required]="props.required || false"
  [disabled]="props.disabled || false"
  [searchable]="props['searchable'] !== false"
  [loading]="props['loading'] || false"
  [virtualScroll]="props['virtualScroll'] || false"
  [appendTo]="'body'"
  [dropdownPosition]="'auto'"
  (open)="onToggle(true)"
  (close)="onToggle(false)"
  class="custom">
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-label">{{
      item[props['bindLabel'] || 'label']
    }}</span>
    <span class="ng-value-icon" (click)="clear(item)" aria-hidden="true"
      >x</span
    >
  </ng-template>

  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-item$="item$">
    <div
      class="checkbox-option"
      (click)="
        toggleSelection(item, item$);
        $event.preventDefault();
        $event.stopPropagation()
      ">
      <input
        id="item-{{ index }}"
        type="checkbox"
        class="form-check-input"
        [checked]="item$.selected"
        (click)="
          toggleSelection(item, item$);
          $event.stopPropagation();
          $event.preventDefault()
        " />
      <label for="item-{{ index }}">{{
        item[props['bindLabel'] || 'label']
      }}</label>
    </div>
  </ng-template>
</ng-select>
